<template>
    <div v-if="rwytype==='longest'">
      <v-row dense :class="headerClass">
        <v-col class="text-left">
          <span class="subtitle-1 font-weight-bold">{{ airport }}</span>
        </v-col>
        <v-col class="text-right">
          <span class="subtitle-1 font-weight-bold">{{data.apt_longest_rwy}} @ {{data.apt_longest_rwy_ft}}'</span>
        </v-col>
      </v-row>
      <v-row dense :class="bodyPrimaryClass">
        <v-col dense cols="3" class="text-left align-self-center" >
          <v-chip small dense v-if="data.aptlongrwysafe === true" color="green darken-1" label class="mt-2 mb-2 white--text">FRO</v-chip>
          <v-chip small dense v-else-if="data.aptlongrwysafe === false" color="yellow darken-2" label class="mt-2 mb-2 black--text">SFRO&nbsp;</v-chip>
        </v-col>
        <v-col dense cols="3" class="text-center align-self-center">
          <v-chip small dense v-if="data.paoverlimit === true" color="red darken-4" label class="mt-2 mb-2 white--text">PAOL</v-chip>
        </v-col>
        <v-col dense cols="6" class="text-right align-self-center">
          <v-btn id="long" x-small text outlined class="mt-2 mb-2" color="blue darken-4" @click="ShowDepartCalcs=true">Show Calcs</v-btn>
        </v-col>
      </v-row>
        <v-row dense>
          <v-col :cols="colsTitle" :class="bodyPrimaryClass" >
            <span>Short Field T/O Roll Ft</span>
          </v-col>
          <v-col :cols="colsData" :class="bodySecondaryClass" >
            {{data.takeoffdistancewithsafety}}
          </v-col>
        </v-row>
        <v-row dense>
          <v-col :cols="colsTitle" :class="bodyPrimaryClass" >
            <span>Short Field Land Roll Ft</span>
          </v-col>
          <v-col :cols="colsData" :class="bodySecondaryClass" >
            {{data.landingdistancewithsafety}}
          </v-col>
        </v-row>
        <v-row dense>
          <v-col :cols="colsTitle" :class="bodyPrimaryClass" >
            <span>Total Roll Ft</span>
          </v-col>
          <v-col :cols="colsData" :class="bodySecondaryClass" >
            {{data.totalgroundrolldistancesafety}}
          </v-col>
        </v-row>
        <v-row dense>
          <v-col :cols="colsTitle" :class="bodyPrimaryClass" >
            <span>Exceeds Rwy Length</span>
          </v-col>
          <v-col :cols="colsData" :class="bodySecondaryClass" >
            {{(data.aptlongrwysafe) === true ? 'No' : 'Yes' }}
          </v-col>
        </v-row>

        <ViewCalcs :visible="ShowDepartCalcs" :data="data" @close="ShowDepartCalcs=false;" title="Short Field Calcs"></ViewCalcs>
     </div>

    <div v-else-if="rwytype==='shortest'">

      <v-row dense :class="headerClass">
        <v-col class="text-left">
          <span class="subtitle-1 font-weight-bold">{{ airport }}</span>
        </v-col>
        <v-col class="text-right">
          <span class="subtitle-1 font-weight-bold">{{data.apt_shortest_rwy}} @ {{data.apt_shortest_rwy_ft}}'</span>
        </v-col>
      </v-row>
      <v-row dense :class="bodyPrimaryClass">
        <v-col dense cols="3" class="text-left align-self-center" >
          <v-chip small dense v-if="data.aptshortrwysafe === true" color="green darken-1" label class="mt-2 mb-2 white--text">FRO</v-chip>
          <v-chip small dense v-else-if="data.aptshortrwysafe === false" color="yellow darken-2" label class="mt-2 mb-2 black--text">SFRO&nbsp;</v-chip>
        </v-col>
        <v-col dense cols="3" class="text-center align-self-center">
          <v-chip small dense v-if="data.paoverlimit === true" color="red darken-4" label class="mt-2 mb-2 white--text">PAOL</v-chip>
        </v-col>
        <v-col dense cols="6" class="text-right align-self-center">
          <v-btn id="short" x-small text outlined class="mt-2 mb-2" color="blue darken-4" @click="ShowDepartCalcs=true">Show Calcs</v-btn>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col :cols="colsTitle" :class="bodyPrimaryClass" >
          <span>Short Field T/O Roll Ft</span>
        </v-col>
        <v-col :cols="colsData" :class="bodySecondaryClass" >
          {{data.takeoffdistancewithsafety}}
        </v-col>
      </v-row>
      <v-row dense>
        <v-col :cols="colsTitle" :class="bodyPrimaryClass" >
          <span>Short Field Land Roll Ft</span>
        </v-col>
        <v-col :cols="colsData" :class="bodySecondaryClass" >
          {{data.landingdistancewithsafety}}
        </v-col>
      </v-row>
      <v-row dense>
        <v-col :cols="colsTitle" :class="bodyPrimaryClass" >
          <span>Total Roll Ft</span>
        </v-col>
        <v-col :cols="colsData" :class="bodySecondaryClass" >
          {{data.totalgroundrolldistancesafety}}
        </v-col>
      </v-row>
      <v-row dense>
        <v-col :cols="colsTitle" :class="bodyPrimaryClass" >
          <span>Exceeds Rwy Length</span>
        </v-col>
        <v-col :cols="colsData" :class="bodySecondaryClass" >
          {{(data.aptshortrwysafe) === true ? 'No' : 'Yes' }}
        </v-col>
      </v-row>

      <ViewCalcs :visible="ShowDepartCalcs" :data="data" @close="ShowDepartCalcs=false;" title="Short Field Calcs"></ViewCalcs>
  </div>

</template>

<script>
  import ViewCalcs from '@/components/told/ViewCalcs';

  export default {
    name: "PerformanceData",
    components: {
            ViewCalcs
    },
      data() {
        return {
          ShowArriveCalcs:false,
          ShowDepartCalcs:false,
          colsTitle: 9,
          colsData: 3,
          headerClass: 'white--text light-blue darken-4',
          panelColor: 'ma-0 pa-0 light-blue lighten-4',
          panelHeaderColor: 'ma-0 pa-0 pl-2 pr-2 white--text light-blue darken-4',
          bodyPrimaryClass: 'body-2 justify-center font-weight-bold light-blue lighten-4',
          bodySecondaryClass: 'ma-0 pa-0 body-2 text-end pr-1 light-blue lighten-4'
      }
    },
    props: {
      data: {type:Object, required:true},
      airport: {type: String, required:true},
      rwytype: {type:String, required: true}
    },
    computed: {
    }
  };
</script>
